import { render, staticRenderFns } from "./ActivityTable.vue?vue&type=template&id=3272fb78&"
import script from "./ActivityTable.vue?vue&type=script&lang=js&"
export * from "./ActivityTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports